import React from 'react';
import { Box } from '@material-ui/core';
import MyCommunitiesCarousel from './community/myCommunitiesCarousel';
import Loader from './common/loader';
import CommunityCategory from './community/communityCategory';
import communityService from '../services/communityService';
import { useFetchData } from '../hooks/fetchDataHooks';
import NotFound from './notFound';
import NoCommunitiesIcon from '../img/communities.svg';
import { useTablet } from '../hooks/utilHooks';

const CommunitiesSearch = () => {
  const isTablet = useTablet();
  const { data: communityCategoryList, isLoading } = useFetchData(
    communityService.getCommunityCategory,
    null
  );

  return (
    <Box width={1} py={2} px={isTablet ? 4 : ''}>
      <MyCommunitiesCarousel />
      {isLoading && <Loader key={1} />}
      <CommunityCategory communityCategoryList={communityCategoryList} />
      {!isLoading && !communityCategoryList && (
        <NotFound
          title="No Communities Found"
          description="Please check spelling or try different communities "
          icon={NoCommunitiesIcon}
        />
      )}
    </Box>
  );
};

export default CommunitiesSearch;
